'use client';

import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';

import { cn } from '@eliadmin/core/src/utils/style-utils';

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
    isDual?: boolean;
  }
>(({ className, isDual, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn('relative flex w-full touch-none select-none items-center', className)}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-[4px] w-full grow cursor-pointer overflow-hidden rounded-full bg-[#D1D1D1]">
      <SliderPrimitive.Range className="absolute h-full bg-primary" />
      {/* <SliderPrimitive.Range className="absolute h-full bg-primary" /> */}
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className="block h-6 w-6 cursor-pointer rounded-full  bg-primary shadow transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50" />
    {isDual && (
      <SliderPrimitive.Thumb className="block h-6 w-6 cursor-pointer rounded-full bg-primary shadow transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50" />
    )}
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
